import { locale, chooseLocale } from '../../translations';

const messages = chooseLocale(locale);

const passwordValidation = (password) => {
  if (!password) return messages['password.message.password'];

  const regex = new RegExp(/^[A-Za-z0-9]{8,12}$/);
  if (!regex.test(password)) return messages['password.message.password.format'];

  return '';
};

class Validation {
  static formValidate = (type, value) => {
    switch (type) {
      case 'password':
      case 'password_confirm':
        return passwordValidation(value);
      default:
        return '';
    }
  };
}

export default Validation;
